export const mockVehicles = [
	// Real UAT vehicles (copied from the M&R vehicles list response) that have
	// issues in the backend — lets the Issues tab be tested against the live
	// issues endpoint.
	{
		vehicleId: 20209,
		plateNumber: "APIAUTOMNR1",
		makeAndModel: "Toyota Sienta",
		platform: "GetGo",
		vehicleStatus: "Active - Active",
		homeLotAddress: "936A YISHUN CENTRAL 1 YISHUN BEACON SINGAPORE 761936",
		lastUpdatedAt: "2026-10-12T02:58:25Z",
		enteredWorkshopAt: null,
		handoverFlagged: false,
		readyForCollection: false,
		issueCounts: {
			total: 10,
			bodywork: 10,
			maintenance: 0,
			nonWorkshop: 0,
		},
	},
	{
		vehicleId: 19267,
		plateNumber: "AD25Y99",
		makeAndModel: "Toyota Sienta",
		platform: "GetGo",
		vehicleStatus: "Active - Active",
		homeLotAddress: "936A YISHUN CENTRAL 1 YISHUN BEACON SINGAPORE 761936",
		lastUpdatedAt: "2026-10-07T05:54:50Z",
		enteredWorkshopAt: null,
		handoverFlagged: true,
		readyForCollection: false,
		issueCounts: {
			total: 25,
			bodywork: 18,
			maintenance: 3,
			nonWorkshop: 4,
		},
	},
	{
		vehicleId: 18991,
		plateNumber: "AD2581",
		makeAndModel: "Toyota Sienta",
		platform: "GetGo",
		vehicleStatus: "Active - Active",
		homeLotAddress: "55 AYER RAJAH CRESCENT SINGAPORE 139949",
		lastUpdatedAt: "2026-10-07T05:16:31Z",
		enteredWorkshopAt: null,
		handoverFlagged: false,
		readyForCollection: false,
		issueCounts: {
			total: 1,
			bodywork: 1,
			maintenance: 0,
			nonWorkshop: 0,
		},
	},
	{
		vehicleId: 10,
		plateNumber: "SLP298G",
		makeAndModel: "Mazda 300",
		platform: "GetGo",
		vehicleStatus: "Active - Active",
		homeLotAddress:
			"88A REDHILL CLOSE MULTI STOREY CAR PARK SINGAPORE 151088",
		lastUpdatedAt: "2026-10-06T07:24:22Z",
		enteredWorkshopAt: null,
		handoverFlagged: false,
		readyForCollection: false,
		issueCounts: {
			total: 0,
			bodywork: 0,
			maintenance: 0,
			nonWorkshop: 0,
		},
	},
	{
		vehicleId: 1926700,
		plateNumber: null,
		makeAndModel: null,
		platform: null,
		vehicleStatus: null,
		homeLotAddress: null,
		lastUpdatedAt: "2026-09-30T04:12:09Z",
		enteredWorkshopAt: null,
		handoverFlagged: false,
		readyForCollection: false,
		issueCounts: {
			total: 1,
			bodywork: 1,
			maintenance: 0,
			nonWorkshop: 0,
		},
	},
];
